import React from 'react'
import AuthForm from '../authForm'

const Register = ({ login }) => {
  return <AuthForm login={login} />;
};

export default Register;
